import api from './client';
import type { AuthResponse } from './types';

/**
 * Login with email and password
 */
export async function login(email: string, password: string): Promise<AuthResponse> {
  return api.post<AuthResponse>('/admin/auth/login', { email, password }, { skipAuth: true });
}

/**
 * Setup first admin account (only works if no admin exists)
 */
export async function setup(email: string, password: string): Promise<AuthResponse> {
  return api.post<AuthResponse>('/admin/auth/setup', { email, password }, { skipAuth: true });
}
